(function ($) {
  'use strict';

  this.TD2024 = function () {};

  $(document).on('click touch', '.contest-cta-link', function () {
    if (typeof fbq === 'function') {
      fbq('track', 'InitiateCheckout');
    }
  });
}).bind(window)(jQuery);
